import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as _ from "lodash";
import {Application} from "../application";
import {SidebarItemType} from "../state/sidebarItemType";
import * as ko from "knockout";
import {IntercomHelper} from "../common/intercom-helper";

export class ShowBookmarksSearchBarCommand implements Command {
    constructor(private app: Application) {
    }

    type: CommandType = CommandType.ShowBookmarksSearchBar;
    canExecute = ko.computed(() => {

        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        
        return true;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        
        if(!this.canExecute())
            return $.Deferred().reject().promise();
        
        if(this.app.state.activeSidebarItem() == SidebarItemType.Bookmarks) {
            IntercomHelper.moveRight();
            this.app.state.activeSidebarItem(undefined);
        } else {
            IntercomHelper.moveLeft();
            this.app.state.activeSidebarItem(SidebarItemType.Bookmarks);
        }
        

        return $.Deferred().resolve().promise();
    }

    name = "Search by Bookmarks";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/showBookmarksSearchBarCommand.ts